export default __webpack_public_path__ + "static/media/Cuisse of the Blood Drinker.337bf133.jpg";